import React, { useContext } from 'react'
import { injectIntl } from 'gatsby-plugin-intl'
import { ThemeContext } from '~/pagui'
import { css } from '@emotion/native'
import { css as hcss } from '@emotion/css'
import { Image } from 'react-native'

type Props = {
  id: any
}

const blockImg = hcss`
position: fixed;
@media (max-width: 960px) {
  display : none ;
`

const logoStyle = css({
  width: 50,
  height: 50,
  resizeMode: 'contain',
})

const SocialMedia: React.FC<Props> = ({ id }) => {
  const [theme] = useContext(ThemeContext)
  const url = `https://www.pagily.io/news/${id}`


  return (
    <>
      <div className={blockImg}>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          target="_blank"
        >
          <Image
            style={[logoStyle, theme.styles.m1]}
            source={{ uri: '/img/demo/facebook.svg' }}
          />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${url}`}
          target="_blank"
        >
          <Image
            style={[logoStyle, theme.styles.m1]}
            source={{ uri: '/img/demo/twitter.svg' }}
          />
        </a>
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
          target="_blank"
        >
          <Image
            style={[logoStyle, theme.styles.m1]}
            source={{ uri: '/img/demo/linkedIn.svg' }}
          />
        </a>
      </div>
    </>
  )
}

export default injectIntl(SocialMedia)
